export const updateCustomerAction = (customerDetails)=>{
    return{type:"UPDATE_CUSTOMER_DETAILS_ACTION",payload:customerDetails}
}

export const updateCutomerData = (updatedData)=>{
    return{type:"UPDATED_CUSTOMER_DATA",payload:updatedData}
}